module.exports = new __parcel__URL__("select-notion-csv.7056786c.svg").toString();